import { createChildTablePrintContainer } from 'factories/ChildTablePrint'
import Component from 'components/Jobs/Print/Tolerances'

export default createChildTablePrintContainer()(Component)
